module.exports = __webpack_public_path__ + "static/img/partner7.d03a17d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/partner7.png
// module id = 7Z0l
// module chunks = 202